module.exports = __webpack_public_path__ + "static/media/myLeadsNoLeadsInList.702a8820.png";